













































































import TinyMce from '@/components/admin/TinyMce.vue'
import UserList from '@/components/admin/users/List.vue'
import TemplateList from '@/components/admin/messages/TemplateList.vue'
import { IEvent } from '@/models/Event'
import User from '@/models/User'
import {
  apiV1AdminEventsPath,
  apiV1AdminMessagePath,
  apiV1AdminMessagesPath,
  apiV1AdminUsersPath
} from '@/rails/routes'
import axios from 'axios'
import Message, { IMessage } from '@/models/Message'
import { Component } from 'vue-property-decorator'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import MessageTemplate from '@/models/MessageTemplate'
import {saveAs} from 'file-saver'
import * as dayjs from 'dayjs'
import {KeyPair} from '@/types/KeyPair'
import UserListCondition from '@/models/shared/UserListCondition'

@Component({
  components: {
    TinyMce,
    UserList,
    TemplateList
  }
})
export default class MessageNew extends PageBase {
  showedTestMail = false
  showedUsers = false
  showedLoadTemplate = false
  from =  `${this.settings.site.title} <${this.settings.mail.from}>`
  message: Message = new Message()
  testEmails = localStorage.getItem('test_emails')
  users: Array<User> = []
  events: Array<IEvent> = []
  progress_statuses = [
    { text: '', value: '' },
    { text: '確定', value: 'fix' },
    { text: '内定', value: 'offer' },
    { text: 'A', value: 'a' },
    { text: 'B', value: 'b' },
    { text: 'C', value: 'c' },
    { text: 'D', value: 'd' },
    { text: 'OB', value: 'ob' },
    { text: 'Z', value: 'z' },
    { text: '関係者', value: 'staff' }
  ]
  active_statuses = [
    { text: '', value: ''},
    { text: '仮登録', value: false },
    { text: '本登録済', value: true }
  ]
  userIds: Array<number> = []
  userListCondition = new UserListCondition()
  usersCount = 0
  usersDetailCount = {}

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'メルマガ一覧',
        to: '/admin/messages',
        exact: true
      },
      {
        text: 'メルマガ新規作成'
      }
    ]
  }

  get usersDetail(): string {
    return this.progress_statuses
      .filter(status => status.value)
      .map(status => {
        const count = this.usersDetailCount[status.value]
        return count ? `${status.text}:${count}` : null
      })
      .filter(detail => detail)
      .join(', ') || '0'
  }

  async mounted(): Promise<void> {
    super.mounted()
    this.userListCondition.status = 2
    await this.reload()
    if (this.$route.query.user_id) {
      this.message.private = true
      const userId = Number(this.$route.query.user_id)
      this.userIds = [userId]
      this.selectUser()
    }
  }

  changeCondition(): void {
    this.message.users = []
    this.userIds = []
    this.userListCondition.page = 1
    this.reloadUsers()
  }

  selectUser(): void {
    this.message.users = this.users.filter(u => u.id === this.userIds[0])
    this.showedUsers = false
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const events = await axios.get<Array<IEvent>>(apiV1AdminEventsPath())
      this.events = [{ id: null, title: '' } as IEvent].concat(events.data)
      if (this.$route.query.source_id) {
        const res = await axios.get<IMessage>(apiV1AdminMessagePath(Number(this.$route.query.source_id)))
        this.message = new Message(res.data)
        this.message.id = null
        this.message.test = false
      }
      await this.reloadUsers()
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async reloadUsers(): Promise<void> {
    try {
      this.showLoading()
      const users = await axios.get(apiV1AdminUsersPath(this.userSearchParams()))
      this.users = users.data.list.map(u => new User(u))
      this.userListCondition.pagenate = users.data.pagenate
      this.usersCount = users.data.pagenate.all_count
      this.usersDetailCount = users.data.detail_count
      this.hideLoading()
    } catch (e) {
      console.error(e)
    }
  }

  async download(): Promise<void> {
    try {
      this.showLoading()
      const res = await axios.get(apiV1AdminUsersPath(this.userSearchParams('xlsx')),
        {
          responseType: 'blob'
        })
      const blob = new Blob([res.data])
      saveAs(blob, `users_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`)
      this.hideLoading()
    } catch (e) {
      console.error(e)
    }
  }

  async test(): Promise<void> {
    if (!this.message.title) {
      this.showError('件名を入力してください')
      return
    }
    if (!this.message.content) {
      this.showError('本文を入力してください')
      return
    }
    this.showedTestMail = false
    const params = this.message.toParams()
    params.test = true
    try {
      await axios.post(apiV1AdminMessagesPath(), {
        test_emails: this.testEmails,
        message: params
      })
      this.showMessage('テストメールを送信しました。')
      localStorage.setItem('test_emails', this.testEmails)
    } catch (e) {
      console.log(e)
    }
  }

  selectTemplate(messageTemplate: MessageTemplate): void {
    this.showedLoadTemplate = false
    this.message.content = messageTemplate.content
  }

  onDelete(messageTemplates: Array<MessageTemplate>): void {
    this.showedLoadTemplate = !!messageTemplates.length
  }

  async send(): Promise<void> {
    if (!this.message.title) {
      this.showError('件名を入力してください')
      return
    }
    if (!this.message.content) {
      this.showError('本文を入力してください')
      return
    }
    if (this.message.private) {
      if (!this.message.users.length) {
        this.showError('対象ユーザーを選択してください')
        return
      }
    }

    this.showConfirm({
      message: 'メルマガを送信します、よろしいですか？',
      onClosed: async (result) => {
        if (!result) {
          return
        }

        const params = this.message.toParams()
        const userSearchParams = this.message.private ? null : this.userSearchParams()
        try {
          this.showLoading()
          await axios.post(apiV1AdminMessagesPath(), {
            message: params,
            users_condition: userSearchParams
          })
          this.hideLoading()
          this.showMessage('メールを送信しました。')
          this.$router.push('/admin/messages')
        } catch (e) {
          console.log(e)
          console.log(e.request.response)
          this.showError(JSON.parse(e.request.response).message)
          this.hideLoading()
        }
      }
    })
  }

  userSearchParams(format?: string): KeyPair {
    const params = this.userListCondition.toParams()
    const q = {
      delete_at_null: true,
      receive_e_zine_eq: true
    }

    if (!this.message.private) {
      q['events_id_eq'] = this.message.event.id || null
      q['progress_status_eq'] = this.message.progress_status
      q['active_eq'] = this.message.active
    }
    params['q'] = q

    if (format) {
      params['format'] = format
    } else {
      params['search_detail_count'] = true
    }

    return params
  }
}
